import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@/components/atoms';
import styles from './Layout.module.css';

export interface HeaderProps {
  title?: string;
  right?: ReactNode;
  /** @deprecated F-170 B3.7 — avatar removed from Mini App header. Prop kept
   *  for API compatibility but ignored; the value never renders. */
  showAvatar?: boolean;
}

/**
 * Mini App top bar.
 *
 * F-170 B1.5 — the bell no longer carries an unread badge. The unread
 * signal now lives in a single place (the bottom-nav "Чати" item) so the
 * user only has one place to look (NN/g H8 minimalist). The
 * notifications-store polling that used to live here moved to the
 * Chats nav item which owns the dot.
 *
 * F-170 B3.7 — the self-avatar slot is gone. The bottom-nav already
 * has a `Я` tab that owns the entrance to `/me`, so the duplicated
 * tap-target in the header was redundant. Title + right-slot only.
 */
export function Header({ title, right }: HeaderProps): JSX.Element {
  return (
    <header className={styles.header}>
      {title ? <h1 className={styles.headerTitle}>{title}</h1> : <span style={{ flex: 1 }} />}
      <div className={styles.headerRight}>
        {right ?? (
          <Link to="/notifications" className={styles.iconBtn} aria-label="Сповіщення">
            <Icon name="bell" size={22} />
          </Link>
        )}
      </div>
    </header>
  );
}
